import { useState } from "react";
import CopyModal from "./CopyModal";
import Button from "react-bootstrap/Button";
import { createComment } from "../../utils/api";
import toast, { Toaster } from 'react-hot-toast';

const TableAction = ({
	wpUserLoggedIn,
	activeTab,
	year,
	setYear,
	currentYear,
	comments,
	setComments,
}) => {
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	const years = Array.from({ length: 21 }, (_, index) => currentYear + index);

	const handleCreateComment = () => {
		createComment(year)
			.then((newComment) => {
				if (newComment.data.data !== '') {
					setComments((comments) => [newComment.data.data, ...comments]);
				}

				if (newComment.data.status === 0) {
					toast.error(newComment.data.message)
					return false;
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleChange = (event) => {
		setYear(event.target.value);
	};

	return (
		<>
			<select
				value={year}
				onChange={handleChange}
				className={"form-select form-select-sm w-auto me-2"}
			>
				{years.map((year) => (
					<option key={year} value={year}>
						{year}
					</option>
				))}
			</select>

			{wpUserLoggedIn && (
				<Button
					variant="link"
					className={"app-button me-2"}
					onClick={handleCreateComment}
				>
					LÄGG TILL RAD
				</Button>
			)}

			{wpUserLoggedIn && (
				<Button
					variant="link"
					className={"app-button"}
					onClick={handleShow}
				>
					KOPIERA
				</Button>
			)}

			<CopyModal
				show={show}
				onHide={handleClose}
				activeTab={activeTab}
				year={year}
			/>
		</>
	);
};

export default TableAction;
